import React from 'react';
import { ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ConfidenceMeterProps {
  confidence: number;
  showLabel?: boolean;
}

const getVariant = (confidence: number): string => {
  if (confidence >= 0.8) return 'success';
  if (confidence >= 0.6) return 'warning';
  return 'danger';
};

const getLabel = (confidence: number): string => {
  if (confidence >= 0.8) return 'Alta';
  if (confidence >= 0.6) return 'Media';
  return 'Baja';
};

const ConfidenceMeter: React.FC<ConfidenceMeterProps> = ({
  confidence,
  showLabel = true,
}) => {
  const percentage = Math.round(confidence * 100);
  const variant = getVariant(confidence);

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Confianza de IA: {percentage}%</Tooltip>}
    >
      <div className="confidence-meter">
        <ProgressBar
          now={percentage}
          variant={variant}
          style={{ height: '8px', minWidth: '80px' }}
        />
        {showLabel && (
          <small className="text-muted ms-2">
            {percentage}% - {getLabel(confidence)}
          </small>
        )}
      </div>
    </OverlayTrigger>
  );
};

export default ConfidenceMeter;
